import { AsyncPipe, NgClass } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService, User } from '@auth0/auth0-angular';
import { AppBarModule } from '@syncfusion/ej2-angular-navigations';
import { NotificationService } from '../shared/service/notification.service';
import { LongTextPipe } from '../shared/pipes/long-text.pipe';
import { DialogModule, TooltipAllModule, TooltipModule } from '@syncfusion/ej2-angular-popups';
import { OcadoAuthService } from '../shared/service/auth.service';
import { OcadoAuth } from '../shared/models/ocado-auth';
import { SharedService } from '../shared/service/shared.service';
import { Subscription } from 'rxjs';
import { promotionConstants } from '../shared/ocado-constants';


@Component({
  selector: 'ocado-home',
  standalone: true,
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  imports: [ RouterOutlet, NgClass, AsyncPipe, AppBarModule, LongTextPipe, TooltipAllModule, TooltipModule, DialogModule ]
})
export class HomeComponent implements OnInit, OnDestroy {
  @HostListener('document:click', [ '$event' ])
  onDocumentClick() {
    this.waffleTooltip ? this.waffleTooltip = false : null;
    this.buildDialog ? this.buildDialog = false : null;
  }
  user!: User | null | undefined;
  authData!: OcadoAuth;
  public notificationCount!: number;
  waffleTooltip: boolean = false;
  buildDialog: boolean = false;
  public activeApplicationList: any = {};
  envName: string = '';
  userSubscription!: Subscription;
  isAuthenticatedSubscription!: Subscription;
  authDataSubscription!: Subscription;
  notificationCountSubscription!: Subscription;
  activeApplicationDetailsSubscription!: Subscription;
  updateNotificationCountSubscription!: Subscription;
  logoutSubscription!: Subscription;

  constructor(public authService: AuthService, public ocadoAuthService: OcadoAuthService, private router: Router, private notificationService: NotificationService, private sharedService: SharedService) {
    this.userSubscription = authService.user$.subscribe(data => {
      this.user = data;
    });
    this.isAuthenticatedSubscription = authService.isAuthenticated$.subscribe(data => {
      if (!data) {
        authService.loginWithRedirect({
          appState: { target: window.location.pathname + window.location.search }
        });
      }
    });
    this.authDataSubscription = this.ocadoAuthService.authData.subscribe(data => {
      this.authData = data;
    });
  }


  ngOnInit(): void {
    this.notificationCountSubscription = this.notificationService.notificationCount.subscribe(data => {
      this.notificationCount = data;
    });
    this.activeApplicationDetailsSubscription = this.sharedService.activeApplicationDetails.subscribe(data => {
      this.activeApplicationList = data;
      this.activeApplicationList.WAFFLE = promotionConstants.Waffle_application_list.filter(value => value.active && (this.ocadoAuthService.isStaff ? (value.staff_only === true || value.staff_only === null) : value.staff_only === null));
    });
    const url = location.origin;
    switch (true) {
      case url.includes('test') || url.includes('tst02'):
        this.envName = 'tst';
        break;
      case url.includes('dev'):
        this.envName = 'dev';
        break;
      case url.includes('ppd-'):
        this.envName = 'ppd';
        break;
      case url.includes('ppd02-'):
        this.envName = 'nfr';
        break;
      case url.includes('localhost'):
        this.envName = 'local';
        break;
      default:
        this.envName = 'prod';
        break;
    }
  }

  waffleOpen(args: MouseEvent) {
    args.stopPropagation();
    this.waffleTooltip = !this.waffleTooltip;
    this.buildDialog = false;
  }
  buildOpen(args: MouseEvent) {
    args.stopPropagation();
    this.buildDialog = !this.buildDialog;
  }

  notificationTab() {
    this.updateNotificationCountSubscription = this.notificationService.updateNotificationCount({ "current_date_time": new Date().toISOString() }).subscribe();
    this.router.navigate([ '/notification' ]);
  }

  home() {
    if (this.ocadoAuthService.isStaff) {
      if (this.ocadoAuthService.privilege.find(p => p.screen_id === 'buyer-dashboard')) {
        this.router.navigate([ 'buyer-dashboard' ]);
      } else {
        this.router.navigate([ 'summary' ]);
      }
    } else {
      this.router.navigate([ 'supplier-dashboard' ]);
    }
  }

  logout() {
    this.logoutSubscription = this.ocadoAuthService.logout().subscribe();
    sessionStorage.clear();
    this.authService.logout({ logoutParams: { returnTo: document.location.origin } });
  }

  ngOnDestroy(): void {
    this.userSubscription?.unsubscribe();
    this.isAuthenticatedSubscription?.unsubscribe();
    this.authDataSubscription?.unsubscribe();
    this.notificationCountSubscription?.unsubscribe();
    this.activeApplicationDetailsSubscription?.unsubscribe();
    this.updateNotificationCountSubscription?.unsubscribe();
    this.logoutSubscription?.unsubscribe();
  }
}
